import { Component, OnInit } from '@angular/core';
import * as jquery from 'jquery';

@Component({
  selector: 'portfolio-navigation',
  templateUrl: './portfolio-navigation.component.html',
  styleUrls: ['./portfolio-navigation.component.scss']
})
export class PortfolioNavigationComponent implements OnInit {

  user: any;
  showNavMenu = false;

  constructor() { }

  ngOnInit(): void {
    this.loadScroll();
  }

  loadScroll() {
    jquery(window).scroll(function() {
      if (jquery(this).scrollTop() > 50) {
        jquery('#header').removeClass('header-scroll-out');
        jquery('#header').addClass('header-scroll');
        jquery('#header-container').addClass('header-container-scroll');
        jquery('#header-logo-desktop').animate({
          width: '124px',
          marginTop: '20px'
        }, 0);
        jquery('#header-logo-mobile').animate({
          width: '30px',
        }, 0);
        jquery('#user-avatar-desktop').animate({
          width: '40px',
          height: '40px'
        }, 0);
        jquery('#user-avatar-desktop-default').animate({
          width: '40px',
          height: '40px'
        }, 0);
        jquery('nav a').addClass('reduced-padding');
        jquery('nav ul').addClass('mt-1');
      } else {
        jquery('#header').removeClass('header-scroll');
        jquery('#header').addClass('header-scroll-out');
        jquery('#header-container').removeClass('header-container-scroll');
        jquery('#header-logo-desktop').animate({
          width: '228px',
          marginTop: '15px'
        }, 0);
        jquery('#header-logo-mobile').animate({
          width: '35px',
        }, 0);
        jquery('#user-avatar-desktop').animate({
          width: '50px',
          height: '50px'
        }, 0);
        jquery('#user-avatar-desktop-default').animate({
          width: '50px',
          height: '50px'
        }, 0);
        jquery('nav a').removeClass('reduced-padding');
        jquery('nav ul').removeClass('mt-1');
      }
    });

    // show menu after 3 seconds
    setTimeout(()=>{
      this.showNavMenu = true;
    }, 3000);

  }

}
